"use client"

import { useMountAdcell } from "src/integrations/adcell/state"
import { StorefrontListProduct } from "src/types/storefront"
import { IntegrationScript } from "../lib/IntegrationScript"
import { adcellPid } from "./constants"

export type AdcellCategoryTagProps = {
  name: string
  handle: string
  products: StorefrontListProduct[]
}

export const AdcellCategoryTag = ({ name, handle, products }: AdcellCategoryTagProps) => {
  const mountAdcell = useMountAdcell()

  if (!mountAdcell) {
    return null
  }

  const productIds = products.flatMap((product) => product.variants.map((variant) => variant.sku)).sort()

  const src = `https://t.adcell.com/js/inlineretarget.js?method=category
&pid=${adcellPid}&categoryName=${name}&categoryId=${handle}
&productIds=${productIds.join(",")}&productSeparator=,`

  return <IntegrationScript id="adcell_category" src={src} />
}
